<template>
  <div class="breadcrumb-wrap">
    <div class="pre-wrap">
      <a-icon type="environment" />
    </div>
    <a-breadcrumb separator="/">
      <a-breadcrumb-item v-for="(item, index) in options" :key="item.name">
        <span @click="toPath(item, index)" class="crumbItem">{{
          item.name
        }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    options: Array
  },
  data () {
    return {}
  },
  mounted () { },
  methods: {
    toPath (instance, index) {
      const preList = this.options.slice(0, index)
      let toRouter = ''
      if (preList.length > 0) {
        preList.forEach((item) => {
          toRouter += `/${item.toRouter}` // 获取前面路由
        })
      }
      toRouter += `/${instance.toRouter}` // 组合当前点击
      const currentRouter = this.$route.path
      if (currentRouter === toRouter) return // 如果点击当前路由直接退出
      let selectedId = this.$route.query.selectedId
      let arr = [
        { toRouter: '/index', name: 'index', query: {} },
        { toRouter: '/resourceNavigation', name: 'resourceNavigation', query: { selectedId, code: "zydh" } },
        { toRouter: '/index/news', name: 'resourceNavigation', query: { selectedId, code: "zydh" } },
        { toRouter: '/index/policy', name: 'resourceNavigation', query: { selectedId, code: "zydh" } },
        { toRouter: '/resourceNavigation/news', name: 'resourceNavigation', query: { selectedId, code: "zydh" } },
        { toRouter: '/resourceNavigation/policy', name: 'resourceNavigation', query: { selectedId, code: "zydh" } },
        { toRouter: '/informationService/analysis', name: 'informationService', query: { selectedId, code: "xinxiServer" } },
        { toRouter: '/informationService/compete', name: 'informationService', query: { selectedId, code: "xinxiServer" } },
        { toRouter: '/informationService/lecture', name: 'informationService', query: { selectedId, code: "xinxiServer" } },
        { toRouter: '/informationService/consult', name: 'informationService', query: { selectedId, code: "xinxiServer" } },
      ]
      
      arr.forEach(item => {
        if (toRouter === item.toRouter) {
          this.$router.push(item)
        }
      })
    }
  }
}
</script>
